<template>
    <div>
        <div class="sousuo" style="width: 100%">
            <div style="width: 450px" class="yl-flex flex_between">
                <Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
                    <i-button slot="append" icon="ios-search"></i-button>
                </Input>
                <Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
                <Button class='ivu-btn-circle' @click="initSearch">重置</Button>
            </div>
        </div>
        <div class="multiple">
            <div class="child-div">时间区间</div>
            <RadioGroup v-model="timePeriod">
                <Radio label="0"><span>不限</span></Radio>
                <Radio label="1"><span>今日</span></Radio>
                <Radio label="2"><span>昨日</span></Radio>
                <Radio label="3"><span>本周</span></Radio>
                <Radio label="4"><span>上周</span></Radio>
                <Radio label="5"><span>本月</span></Radio>
                <Radio label="6"><span>上月</span></Radio>
                <Radio label="7"><span>自定义</span></Radio>
                <DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
                            placeholder="选择日期" style="width: 200px"></DatePicker>
            </RadioGroup>
        </div>

        <div style="width: 100% ;margin-top: 20px;">
            <Table stripe border :columns="columns" :data="datas"  ref="table">									
            </Table>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
	import { getAllMediumCode, getCityTypeStatic} from "../../api/runSet";

	export default {
        name: "AdvAllTypeStatic",
        components: {},
		props: ['AccountStatic'],
        data() {
            return {
                modal: false,
                name: '',
                timePeriod: '2',
                timePeriodDate: [],
                datas: [],
                columns: [
					{
					    "title": "账户类型",
					    "key": "typeName",
						"align":"center",
					},
					{
					    "title": "城市",
					    "key": "city",
						"align":"center",
					},
                    {
                        "title": "消耗",
                        "key": "cost",
						"align":"center",
                        "sortable": true
                    },
                    {
                        "title": "平均成本",
                        "key": "average_cost",
						"align":"center",
                        "sortable": true
                    },										
                    {
                        "title": "广告转化数",
                        "key": "account_convert",
						"align":"center",
                        "sortable": true
                    },
					{
					    "title": "系统转化数",
					    "key": "srcNum",
						"align":"center",
					},
					{
					    "title": "回传数量",
					    "key": "backNum",
						"align":"center",
					},
					{
					    "title": "1星",
					    "key": "one",
						"align":"center",
					},
					{
					    "title": "4星",
					    "key": "four",
						"align":"center",
					},
					{
					    "title": "三星",
					    "key": "threePlus",
						"align":"center",
					},
					{
					    "title": "优质率",
					    "key": "threePlusRate",
						"align":"center",
					},
					{
					    "title": "优质成本",
					    "key": "threePlusCost",
						"align":"center",
					},
                    {
                        "title": "账户展现",
                        "key": "account_show",
						"align":"center",
						"sortable": true
                    },
                    {
                        "title": "账户点击",
                        "key": "account_click",
						"align":"center",
                    },
				],
            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function () {

			this.loadData();
			this.getList();
		},
        methods: {
			
			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = 0;
				this.timePeriodDate = [];
			},
			async loadData() {
				let that = this;
				// let data = {}
				// data.token = this.token;
				// let res = await getAllMediumCode(that, data);
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getCityTypeStatic(that, data);
				that.datas = res.data.list;
			},
			search() {
				this.getList();
			}
        },


    }
</script>
<style scoped lang="less">
    .red {
        color: red;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .hong {
        color: #F56171;
        font-weight: bold;
    }

    .lan {
        color: #124386;
        font-weight: bold;
    }

    .sousuo {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .yl-flex {
        display: flex;
    }

    .flex_between {
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }

    .ivu-table-header thead tr th {
        text-align: center !important;
    }

    .ivu-table-cell {
        padding-left: 2px;
        padding-right: 2px;
        text-align: center;
    }

    .ivu-table table {
        width: 100% !important;
    }

    .green-bg {
        background: #18bc9c;
    }

    .blue-bg {
        background: #54A1F3;
    }

    .person {
        font-size: 14px;
        color: white;
        border-radius: 50%;
        width: 22px;
        height: 20px;
    }

    .in-block {
        display: inline-block;
    }
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
